import React from "react";
import { Typography } from "antd";
import EmployeeList from "../../components/employee/EmployeeList";

const { Title } = Typography;

const EmployeesPage = () => {
  return (
    <div className="employees-container" style={{ padding: "20px" }}>
      <Title level={2}>Çalışanlar</Title>
      <EmployeeList />
    </div>
  );
};

export default EmployeesPage;